
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyPilarXShape as ObiBuoyPilarXShapeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-pilar-x-shape.js';
 
 
 

 
 export const ObiBuoyPilarXShape = createComponent({
   react: React,
   tagName: 'obi-buoy-pilar-x-shape',
   elementClass: ObiBuoyPilarXShapeElement,
   events: {
     
   }
  });
 
 